import React from 'react';
import { Merchandiser } from '../../redux/composableDevice/model/Merchandiser.model';
import { DeviceDetail } from './Components/DeviceDetail';
import { DeviceControlUnitsInformation } from './Components/DeviceControlUnitsInformation';
import { Grid } from '@mui/material';

export const MerchandiserExpertView = (props: {
  merchandiser: Merchandiser;
}) => {
  const { merchandiser } = props;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        <DeviceDetail merchandiser={merchandiser} />
      </Grid>
      <Grid item xs={12} sm={8}>
        <DeviceControlUnitsInformation merchandiser={merchandiser} />
      </Grid>
    </Grid>
  );
};
